module.exports = "<div class=\"ticker-wrapper\">\n  <div class=\"ticker-header\"><div class=\"ticker-header-content\"></div></div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/newsTicker/newsTicker.html
 ** module id = 159
 ** module chunks = 0
 **/